/**
 * Return the `token` search param in the document's URL
 * @param {object} doc A document
 * @returns {string} The `token` search param
 */
export const getToken = (doc) => {
  return new URL(doc.location)?.searchParams?.get('token')
}

/**
 * Return the `location` search param in the document's URL
 * @param {object} doc A document
 * @returns {string} The `location` search param
 */
export const getLocation = (doc) => {
  return new URL(doc.location)?.searchParams?.get('location')
}

/**
 * Return the `referrer` search param in the document's URL
 * @param {object} doc A document
 * @returns {string} The `referrer` search param
 */
export const getReferrer = (doc) => {
  return new URL(doc.location)?.searchParams?.get('referrer')
}

/**
 * Compares two objects based on the specified property in descending order.
 *
 * @param {Object} a - The first object to compare.
 * @param {Object} b - The second object to compare.
 * @param {string} orderBy - The property to use for comparison.
 * @returns {number} - Returns a negative, zero, or positive value
 *                    to indicate the sorting order.
 */
function descendingComparator(a, b, orderBy) {
  const aVal = a[orderBy]
  const bVal = b[orderBy]

  if (typeof bVal === 'string' && typeof aVal === 'string') {
    return bVal.localeCompare(aVal, undefined, {
      numeric: true,
    })
  }

  if (bVal < aVal) {
    return -1
  }
  if (bVal > aVal) {
    return 1
  }
  return 0
}

/**
 * Returns a comparator function based on the specified order and property.
 *
 * @param {string} order - The sorting order ('asc' or 'desc').
 * @param {string} orderBy - The property to use for comparison.
 * @returns {Function} - A comparator function for sorting objects.
 */
export function getComparator(order, orderBy) {
  return (a, b) => {
    const aVal = a[orderBy]
    const bVal = b[orderBy]

    // Push nulls to the end (regardless of sort direction)
    if (aVal == null && bVal != null) return 1
    if (aVal != null && bVal == null) return -1
    if (aVal == null && bVal == null) return 0

    // Regular comparison
    return order === 'desc'
      ? descendingComparator(a, b, orderBy)
      : -descendingComparator(a, b, orderBy)
  }
}
